import { BaseModel, Form, Entry, EntryTypes, Resource } from "@ngx-resource-toolkit/core";
import { environment } from "../../../../environments/environment";
import { LeaResource } from "../../../shared/resource/lea.resource";


@Resource({
    modes: {
        'default': {
            url: environment.proxyUrl + '/parametrage',
            methods: LeaResource.methods
        }
    }
})
@Form ({
    'table': {},
    'edit': {},
})
export class ParametreModel extends BaseModel {
    _explicitType = 'ParametreObject';

    @Entry({
        'table': {
            hidden: true
        },
        'edit': {
            hidden: true
        },
    })
    categorie: string;
    isModifiable: boolean;
    typeParam: string;

    @Entry({
        'table': {
            hidden: true
        },
        'edit': {
            hidden: true
        },
    })
    cle: number;

    @Entry({
        'table': {
            label: 'Libelle',
            flexGrow: 1,
        },
        'edit': {
            label: 'Libelle',
            type: EntryTypes.STATIC,
            css: {
                group: 'col-xs-12'
            }
        },
    })
    libelle: string;

    @Entry({
        'table': {
            label: 'Valeur',
            flexGrow: 1,
        },
        'edit': {
            label: 'Valeur',
            type: EntryTypes.STATIC,
            css: {
                group: 'col-xs-12'
            }
        },
    })
    valeur: string;

    constructor(data?) {
        super();
        if (!data) data = {};

        Object.assign(this, data);
    }
}


// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/parametrage/listes/parametres/parametre.model.ts